import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-label-value-lozenge',
  templateUrl: './label-value-lozenge.component.html',
  styleUrl: './label-value-lozenge.component.scss'
})
export class LabelValueLozengeComponent {
  @Input() label: string;
  @Input() value: string | number;

}
